// © Microsoft Corporation. All rights reserved.

import { ActionHandler, IActionPayload, IReducer } from "@msnews/experiences-redux";
import { SetComponent, SetSocialData, SocialActions } from "./Social.actions";

import { SocialState } from "./Social.state";
import { appEnvironment } from "@msnews/core";

/**
 * The reducer for the Social connector, and the SocialState
 */
export class SocialReducer implements IReducer<SocialState> {
    /**
   * Update the state for the <experience> connector, based on the action being applied
   * @param state The previous state
   * @param actionPayload The action being applied
   */
    public reduce(state: SocialState, actionPayload: IActionPayload): SocialState {
        if (!state) { return {}; }
        if (!actionPayload) { return state; }

        let newState: SocialState;

        ActionHandler.handleAction<SetComponent>(actionPayload, SocialActions.setComponent, (moduleName?: string, id?: string, market?: string, specificCommentId?: string, commentDisplayType?: string) => {
            moduleName = moduleName || state.moduleName;
            id = id || state.id;
            market = market || appEnvironment.CurrentMarket || state.market;
            specificCommentId = specificCommentId || state.specificCommentId;
            commentDisplayType = commentDisplayType || state.commentDisplayType;
            newState = {...state, moduleName, id, market, specificCommentId, commentDisplayType};
        });

        ActionHandler.handleAction<SetSocialData>(actionPayload, SocialActions.setSocialData, (socialData) => {
            newState = { ...state, ...socialData };
        });

        return newState || state;
    }
}